import { render, staticRenderFns } from "./YagiofferDownloadItem.vue?vue&type=template&id=feb0f4d4&scoped=true"
import script from "./YagiofferDownloadItem.vue?vue&type=script&lang=js"
export * from "./YagiofferDownloadItem.vue?vue&type=script&lang=js"
import style0 from "./YagiofferDownloadItem.vue?vue&type=style&index=0&id=feb0f4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb0f4d4",
  null
  
)

export default component.exports